import React from "react";
import PropTypes from "prop-types";
import Step1 from "./Step1";
import Step2 from "./Step2";

const FormStep = ({
  step,
  errors,
  handleInputChange,
  handleSubmit,
  password,
  passwordConfirmation,
}) => {
  let currentStep;

  switch (step) {
    case 2:
      currentStep = <Step2 />;
      break;
    default:
      currentStep = (
        <Step1
          handleSubmit={handleSubmit}
          handleInputChange={handleInputChange}
          password={password}
          passwordConfirmation={passwordConfirmation}
          errors={errors}
        />
      );
      break;
  }
  return currentStep;
};

FormStep.propTypes = {
  step: PropTypes.number.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  errors: PropTypes.shape({}),
};

export default FormStep;
